import Component from 'umg-ember-backend/components/record-explorer';

export default class RecordExplorerForMediaEventComponent extends Component {
  // Defaults
  availableFilters = [
    ...this.defaultFilters,
    {
      key: 'partnerCategoryId',
      type: 'selectValueLabel',
      options: [189, 188, 187],
    },
  ];

  defaultColumns = [
    'id',
    'startDate',
    'artists',
    'headline',
    'partners',
    'cmsState',
    'cmsModified',
  ];

  tableColumns = [
    {
      property: 'id',
      sortable: true,
    },
    {
      property: 'headline',
      isMainColumn: true,
    },
    {
      property: 'startDate',
      sortable: true,
      type: 'date',
      format: 'L',
      align: 'right',
    },
    {
      property: 'startTime',
      align: 'right',
    },
    {
      property: 'endDate',
      type: 'date',
      format: 'L',
      align: 'right',
    },
    {
      property: 'artists',
      type: 'relation',
    },
    {
      property: 'partners',
      type: 'relation',
    },
    {
      property: 'cmsState',
      sortable: true,
      type: 'translate-value',
      align: 'right',
    },
    {
      property: 'cmsModified',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
    {
      property: 'cmsCreated',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
  ];
}
